import { produce } from 'immer'
import { EXAMPLE_ACTION_TYPE } from '../constants'
import TIM from 'tim-js-sdk/tim-js-friendship'
import { resetPageAction } from '../actions/example'

const initState = {
  count: 0,
  inputValue: 'Write Something',
  list: [],
  sensors: {},
  msgList: [],
  // 历史消息
  historyMsgList: [],
  // 当前页数
  currentPage: 1,
  // 是否允许滚动
  isScroll: true,

}

// eslint-disable-next-line
const exampleReducer = (state = initState, action) =>
  // eslint-disable-next-line
  produce(state, (draft) => {
    console.log('action.type', action.type)
    console.log('draft', draft)
    switch (action.type) {
      case EXAMPLE_ACTION_TYPE.UPDATE_COUNT:
        draft.count = action.payload
        break
      case EXAMPLE_ACTION_TYPE.ADD_SENSORS:
        draft.sensors = action.payload
        break
      case EXAMPLE_ACTION_TYPE.UPDATE_MSGLIST:
        console.log('case: EXAMPLE_ACTION_TYPE.UPDATE_MSGLIST')
        if (action.payload.type === 'reset') {
          draft.msgList = []
        } else {
          if (draft.msgList) {
            let list = draft.msgList.filter(item => item.type === TIM.TYPES.MSG_CUSTOM) ?? []
            // 群自定义消息 -- 全局消息 最新的自定义消息如果 payload.extension有值 则 为全局自定义消息
            let lastCustomMsgInfo = list[list.length - 1] ?? {}
            if (lastCustomMsgInfo?.payload?.extension) {
              let userDefinedField = JSON.parse(lastCustomMsgInfo?.payload?.extension ?? '{}')
              console.log(userDefinedField, 'case: EXAMPLE_ACTION_TYPE.UPDATE_MSGLIST')
              switch (userDefinedField.Type) {
                //  飘屏广告
                case 'Live.Ad':
                  let lastIndex = -1
                  draft.msgList.forEach((item, index) => {
                    if (item.type === TIM.TYPES.MSG_CUSTOM) {
                      lastIndex = index
                    }
                  })
                  // eslint-disable-next-line max-depth
                  if (lastIndex !== -1) {
                    draft.msgList[lastIndex].payload.extension = '{}'
                  }
                  break

                default:
                  break
              }
            }
          }
          draft.msgList = transfromArray(draft.msgList.concat(action.payload.list), 'ID')
        }
        break
      case EXAMPLE_ACTION_TYPE.UNSHIFT_MSGLIST:
        console.log('draft.historyMsgList', draft.historyMsgList)
        console.log('action.payload.list', action.payload.list)
        console.log('========')
        draft.historyMsgList = draft.historyMsgList || []
        action.payload.list = action.payload.list || []
        draft.historyMsgList = action.payload.isReset ? action.payload.list : action.payload.list.concat(draft.historyMsgList)
        console.log('draft.historyMsgList 22', draft.historyMsgList)
        break
      // 增加页数
      case 'addPage':
        console.log('addPage', draft.currentPage)
        draft.currentPage += 1
        draft.isScroll = false
        break
      case 'changePageAction':
        console.log('changePageAction', action.payload)
        draft.currentPage = action.payload
        draft.isScroll = false
        break
      case 'setIsScroll':
        console.log('setIsScroll', draft.isScroll)
        console.log('action.payload', action)
        draft.isScroll = action.payload
        break
      default:
        return state
    }
  })
const transfromArray = (list, key) => {
  let obj = {}
  list = list.reduce((cur, next) => {
    if (!obj[next[key]]) {
      obj[next[key]] = true
      cur.push(next)
    }

    return cur
  }, [])
  return list
}
export default exampleReducer
